import HomeContent from 'components/HomeContent/HomeContent';

export default function Home() {
  return (
    <main>
      <HomeContent />
    </main>
  );
}
